import { camelCaseToTitle } from '@treasury/utils';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { checkmarkIcon, circleCloseIcon, clockIcon } from '../assets/icons';
import { TmBaseComponent } from '../tm-base.component';

export const getStatusConfig = (status?: string) => {
    switch (status) {
        case 'Pending':
        case 'PendingApproval':
        case 'Pending Approval':
        case 'Pending Processing':
        case 'Pending Process':
            return {
                icon: clockIcon,
                color: '--content-attention',
            };
        case 'Scheduled':
        case 'Uninitiated':
            return {
                icon: clockIcon,
                color: '--secondary-text-color',
            };
        case 'Rejected':
        case 'Approval Rejected':
        case 'ApprovalRejected':
        case 'Cancelled':
        case 'Deleted':
        case 'Failed':
        case 'Expired':
            return {
                icon: circleCloseIcon,
                color: '--content-negative',
            };
        default:
            return {
                icon: checkmarkIcon,
                color: '--content-positive',
            };
    }
};

export const tagName = 'tm-status';
@customElement(tagName)
export class TmStatus extends TmBaseComponent {
    @property({ attribute: false })
    public status?: string;

    @property({ attribute: false })
    public icon: boolean = true;

    @property({ attribute: false })
    public label: boolean = true;

    protected render() {
        if (!this.status) {
            return nothing;
        }

        return html`<div class="flex justify-end items-center">
            <tm-icon
                .icon=${getStatusConfig(this.status).icon}
                .color=${`var(${getStatusConfig(this.status).color})`}
            ></tm-icon>
            ${this.label
                ? html`<div class="ml-1 text-sm text-header">${camelCaseToTitle(this.status)}</div>`
                : nothing}
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmStatus;
    }
}
